<template>
  <a-layout id="components-layout-demo-top" class="layout">
    <a-layout-content style="padding: 0 50px; flex: 1">
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 16px 0;
        "
      >
        <a-breadcrumb>
          <a-breadcrumb-item>Home</a-breadcrumb-item>
          <a-breadcrumb-item>App</a-breadcrumb-item>
        </a-breadcrumb>
        <div class="change-locale">
          <a-radio-group
            :default-value="enUS"
            @change="changeLocale"
            :value="currentLang"
          >
            <a-radio-button key="en" :value="enUS"> English </a-radio-button>
            <a-radio-button key="cn" :value="zhCN"> 中文 </a-radio-button>
          </a-radio-group>
        </div>
      </div>
      <div class="mt-15">
        <h1>{{ $t("Intelligent-Categorization-Import") }}</h1>
      </div>
      <a-card :bordered="false">
        <a-upload-dragger
          name="file"
          :multiple="false"
          :action="fileUploadUrl"
          :headers="headers"
          @change="handleChange"
          :accept="fileAcceptTypes"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-text">
            {{ $t("Click or drag file to this area to upload") }}
          </p>
          <p class="ant-upload-hint">
            {{ $t("upload info") }}
          </p>
        </a-upload-dragger>
        <a-input-search
          v-model="fileUrl"
          :placeholder="$t('Or paste your file link')"
          size="large"
          @search="fetchImport"
          class="mt-15"
        >
          <a-button slot="enterButton">
            {{ $t("Import") }}
          </a-button>
        </a-input-search>
      </a-card>
      <div class="mt-15">
        <h1>{{ $t("Export") }}</h1>
      </div>
      <a-row :gutter="30">
      <a-col :span="6">
        <a-card :bordered="false">
        <div>
          <h2>{{$t("Custom Collections")}}</h2>
          <p>{{$t("Export manually classified IDs")}}</p>
          <a-button type="primary" :loading="btnCustomExportLoading" icon="download" @click="handleExportExcel('custom_collections.json')">
            {{ $t("Export") }}
          </a-button>
        </div>
      </a-card>
      </a-col>
      <a-col :span="6">
        <a-card :bordered="false">
        <div>
          <h2>{{$t('Smart Collections')}}</h2>
          <p>{{$t('Export smart classified IDs')}}</p>
          <a-button type="primary" :loading="btnSmartExportloading" icon="download" @click="handleExportExcel('smart_collections.json')">
            {{ $t("Export") }}
          </a-button>
        </div>
      </a-card>
      </a-col>
      <a-col :span="6">
        <a-card :bordered="false">
        <div>
          <h2>{{$t("Exporting products")}}</h2>
          <p>{{$t("Exporting product ID and variant ID")}}</p>
          <a-button type="primary" :loading="btnProductLoading" icon="download" @click="handleExportProductExcel">
            {{ $t("Export") }}
          </a-button>
        </div>
      </a-card>
      </a-col>
    </a-row>
  
      
      <div class="mt-15 help-box">
        <h1>{{ $t("Help") }}</h1>
        <div style="margin-top: 5px">
          <span
            ><a-icon
              type="exclamation-circle"
              theme="filled"
              style="color: rgb(53, 109, 255)"
          /></span>
          <span class="help-doc"
            ><a
              href="https://doc.use.cool/import-metafields/use.html"
              target="_blank"
              >{{ $t("help.doc.title") }}</a
            ></span
          >
        </div>
      </div>
      <div style="display: flex; justify-content: space-between; margin: -15px">
        <div style="flex-basis: 50%; margin: 15px">
          <a-card :bordered="false" style="height: 200px">
            <h3>{{ $t("Steps") }}</h3>
            <ol>
              <li>
                {{ $t("Download Template") }}
                <a
                  href="https://zhaobobi.oss-cn-shenzhen.aliyuncs.com/metafields.xlsx"
                  >{{ $t("Download Template Now") }}</a
                >
              </li>
              <li>{{ $t("Prepare data according to the template") }}</li>
              <li>{{ $t("Upload your prepared data") }}</li>
              <li>{{ $t("The system is executing the import") }}</li>
              <li>{{ $t("Operation completed") }}</li>
            </ol>
          </a-card>
        </div>
        <div style="flex-basis: 50%; margin: 15px">
          <a-card :bordered="false" style="height: 200px">
            <h3>{{ $t("Contact us") }}</h3>
            <p>
              {{
                $t(
                  "If you have any questions or suggestions, please feel free to contact us"
                )
              }}：
            </p>
            <ul>
              <li>Email: feihuan@tayun123.com</li>
              <li>{{ $t("Phone") }}: 15116028193</li>
            </ul>
          </a-card>
        </div>
      </div>
    </a-layout-content>
    <a-layout-footer style="text-align: center">
      {{ $t("Smart Categorization Import") }} ©2023 Created by Tayun Team
    </a-layout-footer>
  </a-layout>
</template>
<script>
import enUS from "ant-design-vue/es/locale/en_US";
import zhCN from "ant-design-vue/es/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import { loadLanguageAsync } from "@/locales";
import storage from "store";
import { API_BASE_URL } from "../config";
import { importMetafields, exportExcel, exportProductExcel } from "../api/api";
import { isUsageLimitError, getUsageLimitInfo, formatUsageLimitMessage, redirectToPricing } from "../utils/errorHandler";
import store from "../store/store";
const token = localStorage.getItem("token");
export default {
  data() {
    return {
      enUS,
      zhCN,
      locale: enUS,
      currentLang: enUS,
      isEnglish: true, // 初始语言为英文
      headers: {
        Authorization: `Bearer ${token}`,
      },
      fileUploadUrl: "",
      fileAcceptTypes: ".xls,.xlsx,application/vnd.ms-excel",
      fileUrl: "",
      btnSmartExportloading:false,
      btnCustomExportLoading:false,
      btnProductLoading: false
    };
  },
  created() {
    this.initLang();
    this.fileUploadUrl = API_BASE_URL + "/api/oss/upload";
  },
  methods: {
    initLang() {
      let lang = storage.get("lang");
      if (lang) {
        if (lang === "zh-CN") {
          loadLanguageAsync("zh-CN");
          moment.locale("zh-cn");
          this.locale = zhCN;
          this.currentLang = zhCN;
        }
        if (lang === "en-US") {
          loadLanguageAsync("en-US");
          moment.locale("en");
          this.locale = enUS;
          this.currentLang = enUS;
        }
      }
    },
    changeLocale(e) {
      const localeValue = e.target.value;
      this.locale = localeValue;
      if (localeValue.locale === "zh-cn") {
        loadLanguageAsync("zh-CN");
        this.currentLang = zhCN;
      }
      if (localeValue.locale === "en") {
        loadLanguageAsync("en-US");
        this.currentLang = enUS;
      }
      if (!localeValue) {
        moment.locale("en");
      } else {
        moment.locale("zh-cn");
      }
    },
    handleChange(info) {
      const status = info.file.status;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        this.$message.success(`${info.file.name} file uploaded successfully.`);
        const fileUrl = info.file.response.data.url;
        // this.$message.info("Importing, please wait.");
        this.fetchImportSmartCollections(fileUrl);
      } else if (status === "error") {
        this.$message.error(`${info.file.name} file upload failed.`);
      }
    },
    async fetchImportSmartCollections(fileUrl) {
      const handle = store.state.handle;
      try {
        await importMetafields(fileUrl, handle);
        this.$message.success("Task submitted, please wait for task processing");
      } catch (error) {
        console.error('Metafields import error:', error);
        
        // 尝试解析错误消息为JSON
        let errorResponse = null;
        try {
          errorResponse = JSON.parse(error.message);
        } catch (parseError) {
          // 如果不能解析为JSON，检查是否包含使用限制信息
          if (error.message && error.message.includes('超出月度使用限制')) {
            errorResponse = {
              success: false,
              message: error.message
            };
          }
        }
        
        // 检查是否为使用限制错误
        if (errorResponse && isUsageLimitError(errorResponse)) {
          console.log('Detected usage limit error in metafields import');
          const limitInfo = getUsageLimitInfo(errorResponse);
          const message = formatUsageLimitMessage(limitInfo, this.$t, this.currentLang);
          
          this.$confirm({
            title: this.$t('Usage Limit Exceeded'),
            content: message + '\n\n' + this.$t('Upgrade your plan to continue'),
            okText: this.$t('View Pricing'),
            cancelText: this.$t('Cancel'),
            onOk: () => {
              redirectToPricing(this.$router, message);
            }
          });
        } else {
          this.$message.error(error.message);
        }
      }
    },
    fetchImport() {
      if (!this.fileUrl) {
        this.$message.error("请输入文件链接");
        return;
      }
      this.$message.info("正在导入请稍后");
      this.fetchImportSmartCollections(this.fileUrl);
    },
    async handleExportProductExcel(){
      try {
        const handle = store.state.handle;
        this.$message.info("Please wait, downloading");
        this.btnProductLoading = true;
        await exportProductExcel(handle);
        this.btnProductLoading = false;
      } catch (error) {
        console.error("Failed to export Excel:", error.message);
      }
    },
    async handleExportExcel(categoryType) {
      try {
        const handle = store.state.handle;
        this.$message.info("Please wait, downloading");
        if(categoryType === 'smart_collections.json') {
          this.btnSmartExportloading = true;
        } else {
          this.btnCustomExportLoading = true;
        }
   
        await exportExcel(handle,categoryType);
        
        if(categoryType === 'smart_collections.json') {
          this.btnSmartExportloading = false;
        } else {
          this.btnCustomExportLoading = false;
        }
      } catch (error) {
        console.error("Failed to export Excel:", error.message);
      }
    },
  },
};
</script>

<style>
#components-layout-demo-top .logo {
  width: 120px;
  height: 31px;
  background: rgba(255, 255, 255, 0.2);
  margin: 16px 24px 16px 0;
  float: left;
}

.custom-card {
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.mt-15 {
  margin-top: 15px;
}
.help-box {
  display: flex;
  justify-content: space-between;
}
</style>
  


// WEBPACK FOOTER //
// src/pages/Index.vue